import React from 'react';
import {Box, Illustration, Stack, Text} from "@mbank-design/design-system/components";
import {MobileEmptyShelfCorporate} from "@mbank-design/design-system/illustrations";

export default function Home() {
    return (
        <Box minWidth={[0, 1280]}>
            <Stack>
                <Illustration illustrationComponent={MobileEmptyShelfCorporate} />
                <Text as={"h2"}>there is no invitation to display</Text>
                <Text as={"body"}>please check if you provided a correct link to invitation</Text>
            </Stack>
        </Box>
    );
}
